let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jifTW")).then(() => parcelRequire('guzJ5'));